import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {Observable} from 'rxjs/Observable';
import {Subscription} from 'rxjs/Subscription';
import {isNullOrUndefined} from 'util';
import {OnfidoProfile} from '../../api/entity';
import {IntegrationModuleService, OnfidoService} from '../../api/service';


@Component({
    selector: 'tfo-bo-onfido-verification',
    host: {'class': 'verification-results-block'},
    template: `
        <loading-linear [loading]="loading"></loading-linear>
        <h3>
            <button (click)="createApplicant()"
                    [disabled]="loading"
                    *ngIf="hasNotContactedWithOnfido() && isSupported"
                    class="btn btn-primary verify-btn-box pull-right">
                {{ 'CUSTOMER.VERIFICATION.ONFIDO.CREATE_APPLICANT' | translate }}
            </button>

            {{ 'CUSTOMER.VERIFICATION.ONFIDO.TITLE' | translate }}
        </h3>

        <hr/>

        <ng-container *ngIf="!isSupported">
            <h3 class="text-center">
                {{ 'CUSTOMER.VERIFICATION.ONFIDO.NOT_AVAILABLE' | translate }}
            </h3>
        </ng-container>

        <ng-container *ngIf="isSupported">

            <ng-container *ngIf="!hasNotContactedWithOnfido()">
                <tfl-bo-onfido-client-user
                    *ngFor="let user of onfidoProfile.attachedUsers"
                    [onfidoUser]="user">
                </tfl-bo-onfido-client-user>
            </ng-container>

            <ng-container *ngIf="hasNotContactedWithOnfido()">
                <h3 class="text-center">
                    {{ 'CUSTOMER.VERIFICATION.ONFIDO.EMPTY_PROFILE' | translate }}
                </h3>
            </ng-container>

        </ng-container>
    `
})
export class OnfidoVerificationComponent implements OnInit, OnDestroy {

    onfidoProfile: OnfidoProfile;
    loading = false;
    isSupported = true;

    private profileId: number;
    private httpDetailsSubscription: Subscription = new Subscription();

    constructor(private _onfidoService: OnfidoService,
                private _integrationModuleService: IntegrationModuleService,
                private _activatedRoute: ActivatedRoute) {
    }

    ngOnInit(): void {
        this._activatedRoute.parent.parent.params.subscribe(params => {
            this.loading = true;
            this.profileId = +params['id'];
            this._integrationModuleService.getAvailabilityForClientProfile(this.profileId).subscribe(modules => {
                let foundModule = modules.find(m => m.name === 'ONFIDO');
                this.isSupported = foundModule.available;
            });
            this.fetchVerificationResults();
        });
    }

    ngOnDestroy(): void {
        this.httpDetailsSubscription.unsubscribe();
    }

    hasNotContactedWithOnfido() {
        return isNullOrUndefined(this.onfidoProfile) || this.onfidoProfile.attachedUsers.length === 0;
    }

    createApplicant() {
        this.loading = true;
        this._onfidoService
            .createApplicant(this.profileId)
            .subscribe(_ => {
                // For each 3 seconds
                this.httpDetailsSubscription = Observable
                    .interval(1000 * 3)
                    // While results don't have applicant ids
                    .takeWhile(() => this.loading)
                    .subscribe(_ => {
                        // Fetch profile and check attached users to be at least created in onfido regardless of statuses
                        this._onfidoService
                            .getResult(this.profileId)
                            .subscribe(results => {
                                this.onfidoProfile = results;

                                if (!this.hasNotContactedWithOnfido()) {
                                    this.loading = false;
                                }
                            });
                    });
            });
    }

    private fetchVerificationResults() {
        if (this.isSupported) {
            this.loading = true;
            this._onfidoService
                .getResult(this.profileId)
                .subscribe(results => {
                    this.onfidoProfile = results;
                    this.loading = false;
                });
        }
    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/modules/customers/shared/components/onfido/onfido.verification.component.ts